/* eslint-disable no-param-reassign */
/* eslint-disable default-case */
import produce from 'immer';

import { SYNC_USER, SYNC_CONFIG, ACTION_SET_SYNC_STORE } from './constants';

import theme from './themes';

const initialState = {
  syncStore: {},
  user: null,
  config: null,
  theme: {
    breakpoints: theme.breakpoints,
    space: theme.spaces,
    fontSize: theme.fontSizes,
    fontWeight: theme.fontWeights,
    lineHeight: theme.lineHeights,
    letterSpacing: theme.letterSpacings,
    fonts: theme.fonts,
    color: theme.colors,
  },
};

const globalReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case ACTION_SET_SYNC_STORE:
        Object.keys(action.syncStore).forEach(syncStoreKey => {
          draft.syncStore[syncStoreKey] = action.syncStore[syncStoreKey];
        });
        break;
      case SYNC_USER:
        draft.user = action.user;
        break;
      case SYNC_CONFIG:
        draft.config = action.config;
        break;
    }
  });

export default globalReducer;
